<template>
  <div class="footer">
    <div class="f-container">
      <div class="row">
        <div class="col">
          <img width="96" src="@/assets/img/logo1.png" alt="" />
          <div class="desc">
            {{ t('bottom.slogan') }}
          </div>
        </div>
        <div class="col">
          <div class="box" v-if="route.path === '/urltovideo'">
            <div class="title">{{ t('bottom.title') }}</div>
            <div class="label" v-for="item in products" :key="item.label">
              <a
                :href="user.lang === 'zh' ? item.zhUrl : item.url"
                target="_blank"
                >{{ item.label }}</a
              >
            </div>
          </div>
          <div class="box" v-else>
            <div class="title">{{ t('bottom.title') }}</div>
            <div class="label" v-for="item in product" :key="item.label">
              <a :href="item.url" target="_blank">{{ item.label }}</a>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="box">
            <div class="title">{{ t('bottom.title1') }}</div>
            <div class="label">
              <img width="24" src="@/assets/img/address.png" alt="" />
              #14-06, 6 Raffles Quay, Singapore
            </div>
            <div class="label">
              <img width="24" src="@/assets/img/email.png" alt="" />
              support@laipic.ai
            </div>
            <div class="label">
              <a
                href="https://www.youtube.com/channel/UCEXlYrC-iETysSJwq5rOwXA"
                target="_blank"
              >
                <img width="24" src="@/assets/img/youtube.png" alt="" />
                {{ t('bottom.youtube') }}
              </a>
            </div>
            <div class="label">
              <a
                href="https://www.facebook.com/profile.php?id=61550910375870"
                target="_blank"
                ><img width="24" src="@/assets/img/facebook.png" alt="" />
                {{ t('bottom.facebook') }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { reactive, watch } from 'vue';
import { useLoginStore } from '@/store';
import { scrollToHash as scrollToHashTarget } from '@/utils/scroll';
const { t } = useI18n();
import { useRoute } from 'vue-router';
const user = useLoginStore();
// const aboutArr = reactive([
//   {
//     label: "Our Partners",
//     url: "#partners",
//   },
//   {
//     label: "Our Ai Products Matrix",
//     url: "#products",
//   },
//   {
//     label: "Proven Results",
//     url: "#results",
//   },
//   {
//     label: "Honor Of Laipic",
//     url: "#honor",
//   },
//   {
//     label: "About Laipic",
//     url: "#about",
//   },
//   {
//     label: "Our Mission",
//     url: "#mission",
//   },
//   {
//     label: "History Of Laipic",
//     url: "#history",
//   },
// ]);
const sdkurl = import.meta.env.VITE_CHATSDK;
const products = reactive([
//   {
//     label: t('home.name'),
//     url: '/',
//     zhUrl: '/',
//   },
  {
    label: t('bottom.product1'),
    url: 'https://www.laipic.ai/chatsdk/editor',
    zhUrl: 'https://www.laihua.com/chatsdk/',
  },
  {
    label: t('bottom.product2'),
    url: 'https://www.doratoon.com',
    zhUrl: 'https://www.laihua.com/',
  },
  {
    label: t('bottom.product3'),
    url: 'https://www.doratoon.com/openapi/en-US',
    zhUrl: 'https://www.laihua.com/openapi/zh-CN',
  },
  {
    label: t('bottom.product5'),
    url: 'https://www.innaio.net/',
    zhUrl: 'https://www.innaio.net/',
  },
  //   {
  //     label: t('bottom.product2'),
  //     url: 'https://www.doratoon.com/',
  //   },
  //   {
  //     label: t('bottom.product3'),
  //     url: urltoads,
  //   },
  //   {
  //     label: t('bottom.product4'),
  //     url: sdkurl,
  //   },
  //   {
  //     label: t('bottom.product5'),
  //     url: 'https://aistore.panda72.ai',
  //   },
]);
const product = reactive([
  {
    label: t('bottom.product1'),
    // url: "/urltovideo",
    url: 'https://www.doratoon.com',
  },
  {
    label: t('bottom.product2'),
    url: sdkurl,
  },
  {
    label: t('bottom.product3'),
    // url: urltoads,
    url: '/urltovideo',
  },
  //   {
  //     label: t('bottom.product4'),
  //     url: sdkurl,
  //   },
  {
    label: t('bottom.product5'),
    url: 'https://www.innaio.net/',
  },
]);
const route = useRoute();
watch(route, () => {
  scrollToHash();
});
function scrollToHash() {
  setTimeout(() => {
    if (route.hash) {
      scrollToHashTarget(route.hash);
    }
  }, 10);
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 420px;
  background: #fff;
  padding-top: 75px;
  // padding-bottom: 71px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  font-family: Inter-Medium;
  color: #333;

  .f-container {
    width: 1034px;
    margin: 0 auto;
    position: relative;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 101px;
    height: 39px;
    background: #ffffff;
    border-radius: 1px 1px 1px 1px;
  }

  .row {
    display: flex;
    justify-content: flex-start;
  }

  .col {
    width: 45%;
    display: flex;
    justify-content: flex-end;

    &:nth-child(1) {
      display: block;
      width: 30%;
    }

    &:nth-child(2) {
      width: 25%;
    }
  }

  .col {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    text-align: left;

    // .box {
    //   width: 180px;
    // }
    .desc {
      width: 320px;
      height: 72px;
      font-family: Inter-Medium, Inter;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 48px;
    }

    .title {
      font-family: Inter-Semi Bold, Inter;
      font-weight: normal;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 48px;
    }

    .label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 27px;
      height: 24px;

      img {
        margin-right: 10px;
      }

      div {
        cursor: pointer;
      }
    }

    a {
      font-family: Inter-Medium, Inter;
      font-weight: 500;
      font-size: 14px;
      color: #333;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      text-decoration: unset;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    a:hover {
      color: #666;
      //   text-decoration: underline;
    }

    .text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 16px;
      font-weight: 500;
    }

    .icon-box {
      margin-top: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }
}
</style>
